import React from "react";
import { Paper, Typography, Grid } from "@mui/material";
import pullListLabels from "../../util/PullListLabels";

const LegacyLabsDetails = ({ labLegacyAddress }) => {
    return (
        <>
            {(labLegacyAddress) && (
                <Paper
                    sx={{
                        paddingLeft: 4,
                        paddingRight: 4,
                        paddingTop: 3,
                        paddingBottom: 3,
                        marginTop: 1,
                        marginBottom: 1,
                        background: "#f2f3f6;",
                        boxShadow: "none",
                    }}
                >
                    <Grid container>
                        <Grid item xs="auto">
                            <Typography fontWeight="bold">
                                {pullListLabels.labLegacyAddress}
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography whiteSpace="pre-wrap" style={{ marginLeft: '32px' }}>
                                {labLegacyAddress}
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>
            )}
        </>
    );
};

export default LegacyLabsDetails;